import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { getArticle } from '../../actions/dataActions'
import { fetchArticleSalesPrice } from '../../actions/receiptActions'
import * as general from '../../constants/General'

// Read-only button that shows the sales price of a single article, so the price does not have to
// be part of the kiosk background image. Position and size are handled like any other key layout
// item, the look of the price comes from the item params: Font (family), FontSize (in px), Color
// and BackgroundColor. An empty value means "not set": the POS font is kept, the text colour is
// inherited and the background stays transparent. The button's own image (fileAttachmentId) is
// layered on top of the background colour, with the price drawn on top of that.
function ArticlePrice(props) {
    const {
        width,
        height,
        top,
        left,
        itemparam,
        fileAttachmentId,
        getArticle,
        fetchArticleSalesPrice
    } = props;

    let param = {};
    if (itemparam) {
        try {
            param = JSON.parse(itemparam) || {};
        } catch (e) {
            param = {};
        }
    }

    const style = {
        position: 'absolute',
        width: `${width}%`,
        height: `${height}%`,
        top: `${top}%`,
        left: `${left}%`,
        backgroundColor: param.BackgroundColor ? param.BackgroundColor : 'transparent'
    };

    if (fileAttachmentId > 0) {
        // Painted on top of backgroundColor by the browser, since both are background layers of the same element
        style.backgroundImage = `url('${general.API_URL_BUTTON_IMAGE}/${fileAttachmentId}')`;
        style.backgroundRepeat = 'no-repeat';
        style.backgroundSize = 'cover';
        style.backgroundPosition = 'center';
    }

    if (param.Color) {
        style.color = param.Color;
    }

    if (param.Font) {
        // Fall back to the POS font when the chosen font is not installed on this kiosk
        style.fontFamily = `'${param.Font}', 'Open Sans', sans-serif`;
    }

    const fontSize = parseInt(param.FontSize, 10);
    if (fontSize > 0) {
        style.fontSize = `${fontSize}px`;
    }

    const articleId = parseInt(param.SetArticle, 10);
    const article = articleId > 0 ? getArticle(articleId) : null;

    if (article === null) {
        return <div style={style} className="articlePrice" />;
    }

    const salesPrice = fetchArticleSalesPrice(article) || 0;

    return (
        <div style={style} className="articlePrice">
            &euro;{salesPrice.toFixed(2).replace('.', ',')}
        </div>
    );
}

ArticlePrice.propTypes = {
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired,
    left: PropTypes.number.isRequired,
    itemparam: PropTypes.string,
    fileAttachmentId: PropTypes.number,
    getArticle: PropTypes.func.isRequired,
    fetchArticleSalesPrice: PropTypes.func.isRequired
}

function mapStateToProps(state) {
    return {
        // Mapped so the price is redrawn when the articles are (re)loaded or another price list is selected
        articles: state.generalState.articles,
        pricelistid: state.receiptState.receipt.pricelistid
    }
}

export default connect(mapStateToProps, { getArticle, fetchArticleSalesPrice })(ArticlePrice)



// WEBPACK FOOTER //
// src/freeformat/components/ArticlePrice.jsx